<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.cdSn" placeholder="订单号" @input="getOrders" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-select v-model="filters.providerId" filterable placeholder="销售公司" @change="getOrders" clearable>
					    <el-option
					      v-for="item in providers"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
				  	</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="filters.demanderId" filterable placeholder="需求公司" @change="getOrders" clearable>
					    <el-option
					      v-for="item in demanders"
					      :key="item.id"
					      :label="item.name+item.contacter+item.phone"
					      :value="item.id">
					    </el-option>
				  	</el-select>
				</el-form-item>
				<el-form-item label="">
					<el-date-picker
				      v-model="filters.dates"
				      type="daterange"
				      align="left"
				      unlink-panels
				      range-separator="至"
				      start-placeholder="订单开始日期"
				      end-placeholder="结束日期"
				      :picker-options="pickerOptions"
				      @change="getOrders">
				    </el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-select v-model="filters.payway" placeholder="付款方式" @change="getOrders" clearable >
					    <el-option
					      v-for="item in payway"
					      :key="item.value"
					      :label="item.label"
					      :value="item.value">
					    </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.remark" placeholder="备注" @input="getOrders" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="warning" v-on:click="goAddView">新建销货单</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="success" @click="exportAll" >导出</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="orders" highlight-current-row v-loading="listLoading" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="cdSn" label="订单号" width="150">
			</el-table-column>
			<el-table-column prop="provider" show-overflow-tooltip label="销售公司" width="200">
			</el-table-column>
			<el-table-column prop="demander" show-overflow-tooltip label="需求公司" width="200">
			</el-table-column>
			<el-table-column prop="sum" label="订单金额" width="100">
			</el-table-column>
			<el-table-column prop="count" label="物品数量" width="100">
			</el-table-column>
			<el-table-column prop="payway" label="付款方式" :formatter="formatPayway" width="88">
			</el-table-column>
			<el-table-column prop="createTime" label="开单日期" width="200">
			</el-table-column>
			<el-table-column prop="remark" label="备注" width="150">
			</el-table-column>
			<el-table-column label="操作" width="250">
				<template scope="scope">
					<el-button type="info" size="small" @click="handleView(scope.$index, scope.row)" icon="el-icon-search"></el-button>
					<el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit"></el-button>
					<el-button size="small" v-if="isAdmin" @click="handleCopy(scope.$index, scope.row)" >冲红</el-button>
					<el-button type="danger" size="small" v-if="isAdmin" @click="handleDel(scope.$index, scope.row)" icon="el-icon-delete"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--订单详情界面-->
		<el-dialog title="订单详情" :visible.sync="orderGoodsVisible" :close-on-click-modal="false">
			<el-table :data="orderGoods" highlight-current-row v-loading="orderGoodsLoading" style="width: 100%;" @selection-change="selsChange">
				<el-table-column type="selection" width="50">
			    </el-table-column>
			    <el-table-column type="index" width="45">
				</el-table-column>
				<el-table-column prop="name" label="商品名称" width="150" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="brand" label="品牌" width="70">
				</el-table-column>
				<el-table-column prop="form" label="规格" width="200" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="unit" label="单位" width="70">
				</el-table-column>
				<el-table-column prop="count" label="数量" width="90">
				</el-table-column>
				<el-table-column prop="price" label="单价" width="80">
				</el-table-column>
			</el-table>

			<!-- 打印插件安装提示 -->
			<div id="footer"></div>

			<div slot="footer" class="dialog-header">
				<!-- <el-button type="warning" @click.native="handleDesign()">设计</el-button>  -->
				<el-button type="warning" v-if="this.sels.length>0" @click="handlePrint()">打印送货单</el-button>
				<el-button type="warning" v-if="this.sels.length>0" @click.native="handleEditOrderGoods">修改</el-button>
				<el-button type="danger" v-if="this.sels.length>0" @click.native="handleDelOrderGoods">删除</el-button>
				<el-button type="info" @click.native="handleAddOrderGoods">增加</el-button>
				<el-button type="success" @click.native="exportToExcel">导出到excel</el-button>
			</div>
		</el-dialog>

		<!--修改订单物料界面-->
		<el-dialog title="修改" :visible.sync="editOrderGoodsVisible" :close-on-click-modal="false">
			<el-form :model="editOrderGoodsForm" label-width="80px" ref="editOrderGoodsForm" :inline="true">
				<el-table :data="orderGoods" highlight-current-row style="width: 100%;" >
					<el-table-column prop="name" label="商品名称" width="150">
					</el-table-column>
					<el-table-column prop="brand" label="品牌" width="70">
					</el-table-column>
					<el-table-column prop="form" label="规格" width="200">
					</el-table-column>
					<el-table-column prop="unit" label="单位" width="70">
					</el-table-column>
					<el-table-column prop="count" label="数量" width="100">
						<template scope="scope">
							<el-input type="number" v-model="scope.row.count" size="mini" :min="1" :maxlength="10" ></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="price" label="单价" width="100">
						<template scope="scope">
							<el-input type="number" v-model="scope.row.price" size="mini" :min="1" :maxlength="10" ></el-input>
						</template>
					</el-table-column>
					
				</el-table>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editOrderGoodsVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editOrderGoodsSubmit" :loading="editOrderGoodsLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="80px" ref="editForm">
				<el-form-item label="销售公司" prop="providerId">
					<el-select v-model="editForm.providerId" filterable placeholder="请选择" clearable>
					    <el-option
					      v-for="item in providers"
					      :key="item.id"
					      :label="item.name"
					      :value="item.id">
					    </el-option>
				  	</el-select>
				</el-form-item>
				<el-form-item label="需求公司" prop="demanderId">
					<el-select v-model="editForm.demanderId" filterable placeholder="请选择" clearable>
					    <el-option
					      v-for="item in demanders"
					      :key="item.id"
					      :label="item.name+item.contacter+item.phone"
					      :value="item.id">
					    </el-option>
				  	</el-select>
				  	<i v-on:click="handleDemanderAdd" class="fa fa-user-plus"></i>
				</el-form-item>
				<el-form-item label="付款方式" prop="payway">
					<el-radio v-model="editForm.payway" label="1">支付宝
				    </el-radio>
				    <el-radio v-model="editForm.payway" label="2">微信
				    </el-radio>
				    <el-radio v-model="editForm.payway" label="3">现金
				    </el-radio>
				    <el-radio v-model="editForm.payway" label="4">记账
				    </el-radio>
				    <el-radio v-model="editForm.payway" label="5">POS
				    </el-radio>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增需求公司界面-->
		<el-dialog title="新增需求公司" :visible.sync="addDemanderFormVisible" :close-on-click-modal="false">
			<el-form :model="addDemanderForm" label-width="80px" :rules="addDemanderFormRules" ref="addDemanderForm">
				<el-form-item label="公司名" prop="name">
					<el-input v-model="addDemanderForm.name" clearable></el-input>
				</el-form-item>
				<el-form-item label="联系人" prop="contacter">
					<el-input v-model="addDemanderForm.contacter" clearable></el-input>
				</el-form-item>
				<el-form-item label="联系电话" prop="phone">
					<el-input v-model="addDemanderForm.phone" :maxlength="11" clearable></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addDemanderFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addDemanderSubmit" :loading="addDemanderLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--物料列表界面-->
		<el-dialog title="商品列表" :visible.sync="goodsVisible" :close-on-click-modal="false">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="输入名称或条码" @input="getGoods" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.form" placeholder="输入规格" @input="getGoods" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.brand" placeholder="输入品牌" @input="getGoods" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="handleGoodsAdd" >新增</el-button>
				</el-form-item>
			</el-form>
			<span style="color:red;font-size:18px">*提示: 修改商品单价和数量后，在数量栏按回车键即可新增，数量默认为1</span>
			<!--列表-->
			<el-table :data="goods" highlight-current-row v-loading="listLoading" style="width: 100%;margin-top:10px" height="300">
			    <el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="barCode" label="条形码" width="90">
				</el-table-column>
				<el-table-column prop="name" label="名称" width="120">
				</el-table-column>
				<el-table-column prop="brand" label="品牌" width="80">
				</el-table-column>
				<el-table-column prop="form" label="规格" width="150">
				</el-table-column>
				<el-table-column prop="unit" label="单位" width="80">
				</el-table-column>
				<el-table-column prop="price" label="单价" width="100">
					<template scope="scope">
						<el-input type="number" size="mini" min="1" :maxlength="10" v-model="scope.row.price" :key="scope.row.id"></el-input>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="数量" width="120">
					<template scope="scope">
						<el-input type="number" size="mini" :min="1" :max="99999" v-model="scope.row.count" :key="scope.row.id" @keyup.enter.native="handleKeyPress(scope.$index, scope.row)" ></el-input>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination layout="prev, pager, next" @current-change="handleGoodsCurrentChange" :page-size="pageSize" :total="goodsTotal" style="float:right;">
			</el-pagination>
		</el-dialog>

		<!--新增商品界面-->
		<el-dialog title="新增商品" :visible.sync="addGoodsFormVisible" :close-on-click-modal="false">
			<el-form :model="addGoodsForm" label-width="80px" :rules="addGoodsFormRules" ref="addGoodsForm">
				<el-form-item label="条形码" prop="barCode">
					<el-input v-model="addGoodsForm.barCode"></el-input>
				</el-form-item>
				<el-form-item label="名称" prop="name">
					<el-input v-model="addGoodsForm.name" @input="getFirstLetter"></el-input>
				</el-form-item>
				<el-form-item label="大写" prop="firstLetter">
					<el-input v-model="addGoodsForm.firstLetter"></el-input>
				</el-form-item>
				<el-form-item label="品牌" prop="brand">
					<el-input v-model="addGoodsForm.brand"></el-input>
				</el-form-item>
				<el-form-item label="规格" prop="form">
					<el-input v-model="addGoodsForm.form"></el-input>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
					<el-input v-model="addGoodsForm.unit"></el-input>
				</el-form-item>
				<el-form-item label="价格" prop="price">
					<el-input type="number" v-model="addGoodsForm.price" :min="0" :max="99999"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addGoodsFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addGoodsSubmit">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import util from '../../common/js/util'
	import '../../common/js/pinyinUtil.js'
	import Cookies from 'js-cookie'
	import _ from 'lodash';
	import {getLodop} from '../../common/js/LodopFuncs'
	import { getOrderList, editOrder, getOrderDetail, delOrder, getProviderList, getDemanderList, addDemander, editOrderDetail, delOrderDetail, getGoodsList, addOrderDetail,  addGoods, getOrderListExport} from '../../api/api';

	var LODOP
	export default {
		data() {
			return {
				pageSize:20,
				pages:0,

				// printSize:6,
				printSize:12,

				isAdmin: Cookies.get('user_type')==1,
				userInfo: JSON.parse(Cookies.get('user_info')),
				filters: {
					cdSn: '',
					providerId:'',
					demanderId: '',
					payway: '',
					dates: '',
					remark: ''
				},
				orders: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],//列表选中列

				//送货单界面
				deliveryOrderVisible: false,//查看页面是否显示

				//修改订单商品
				editOrderGoodsVisible: false,
				editOrderGoodsLoading: false,
				editOrderGoodsForm:{
				},

				//删除订单商品
				delOrderGoodsVisible: false,
				delOrderGoodsForm:{
				},

				//新增订单页面
				orderAddVisible: false,//查看页面是否显示
				orderAddLoading: false,
				addOrderForm: {},

				//查看订单详情页面
				orderGoodsVisible: false,//查看页面是否显示
				orderGoodsLoading: false,
				orderGoods: [],//物料列表

				//发货界面数据
				sendForm: {},

				//编辑订单界面
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editForm: {
				},

				//销售公司
				providers: [],
				//需求公司
				demanders: [],
				addDemanderFormVisible: false,//新增界面是否显示
				addDemanderLoading: false,
				addDemanderFormRules: {
					contacter: [
						{ required: true, message: '请输入联系人', trigger: 'blur' }
					],
					phone: [
						{ required: true, message: '请输入联系电话', trigger: 'blur' }
					]
				},
				addDemanderForm: {
				},

				//商品新增
				addGoodsForm:{
				},
				addGoodsFormVisible:false,
				addGoodsFormRules: {
					name: [
						{ required: true, message: '请输入商品名称', trigger: 'blur' }
					],
					unit: [
						{ required: true, message: '请输入单位', trigger: 'blur' }
					]
				},

				//新增商品
				addForm:{},
				goods:[],
				goodsVisible: false,
				goodsTotal: 0,
				goodsPage: 1,

				//选中金额
				selSum: 0,

				beforeEditCount: 0,
				afterEditCount: 0,
				beforeEditSum: 0,
				afterEditSum: 0,

				//付款方式
				payway:[
					{
						value:1,
						label:this.getStrByPayway(1)
					},
					{
						value:2,
						label:this.getStrByPayway(2)
					},
					{
						value:3,
						label:this.getStrByPayway(3)
					},
					{
						value:4,
						label:this.getStrByPayway(4)
					},
					{
						value:5,
						label:this.getStrByPayway(5)
					}
				],

				pickerOptions: {
		          shortcuts: [{
		            text: '最近一个月',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365/12);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近三个月',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365/4);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近半年',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365/2);
		              picker.$emit('pick', [start, end]);
		            }
		          }, {
		            text: '最近一年',
		            onClick(picker) {
		              const end = new Date();
		              const start = new Date();
		              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
		              picker.$emit('pick', [start, end]);
		            }
		          }]
		        },
		        // 初始化一个debounce函数
      			handleKeyPress:_.debounce(this.handleAdd, 300) // 500毫秒内只触发一次
			}

			
		},
		methods: {
		    //多选
			selsChange: function (sels) {
				this.sels = sels;
				this.selSum = 0;
				sels.forEach(item => {
					this.selSum = util.formatNumber(this.selSum + item.price*item.count);
				})
			},
		    //显示新增订单商品界面
			handleAddOrderGoods: function (){
				this.orderGoodsVisible = false;
				this.filters.name='';
				this.filters.form='';
				this.filters.brand='';
				this.goods=[];
				this.getGoods();
				this.goodsVisible = true;
			},
			//获取物料列表
			getGoods() {
				let para = {
					page:this.goodsPage,
                    size:this.pageSize,
                    name:this.filters.name,
                    brand:this.filters.brand,
                    form:this.filters.form
				};
				getGoodsList(para).then((res) => {
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.goods = res.data.data.list
						this.goodsPage = res.data.data.pageNum == 0 ? res.data.data.pageNum +1 : res.data.data.pageNum
	                    this.goodsTotal = res.data.data.total
	                }
				});
			},
			//新增物料
			handleAdd: function (index, row) {
				this.goodsVisible = false;
				//默认数量为1
				if(row.count == 0){
					row.count++;
				}
				let newItem = Object.assign({}, row);
				newItem.status = util.formatNumber(row.count);
				this.addForm.goodsList = [];
				this.addForm.goodsList.push(newItem);
				//计算金额
				let sum = this.sendForm.sum + (newItem.price * newItem.status);
				this.addForm.sum = util.formatNumber(sum);
				this.addForm.count = this.sendForm.count + newItem.status;
				this.addForm.id = this.sendForm.id;
				//发送请求
				addOrderDetail(this.addForm).then((res) => {
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.getOrders();
						this.addForm={};
					}
				});
			},

			//显示新增商品界面
			handleGoodsAdd: function () {
				this.addGoodsFormVisible = true;
				this.addGoodsForm = {
					barCode: '',
					name: '',
					firstLetter: '',
					brand: '',
					form: '',
					unit: '',
					price: 0,
				};
			},
			//新增商品
			addGoodsSubmit: function () {
				this.$refs.addGoodsForm.validate((valid) => {
					if (valid) {
						let para = Object.assign({}, this.addGoodsForm);
						addGoods(para).then((res) => {
							this.addGoodsFormVisible = false;
							let msg = res.data.message;
		                	let code = res.data.code;
							if (code !== 200) {
			                  this.$message({
			                    message: msg,
			                    type: 'error'
			                  });
			                } else {
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.getGoods();
								this.$refs['addGoodsForm'].resetFields();
							}
						});
					}
				});
			},

			//分页
			handleCurrentChange(val) {
				this.page = val;
				this.getOrders();
			},
			handleGoodsCurrentChange(val) {
				this.goodsPage = val;
				this.getGoods();
			},
			//导出订单物料
			exportToExcel() {
    			let exportItems=[];
    			exportItems = this.orderGoods;
				require.ensure([], () => {
			　　　const { export_json_to_excel } = require('../../excel/Export2Excel');
			　　　const tHeader = ['名称','品牌','规格','单位','数量','价格'];
			　　　// 上面设置Excel的表格第一行的标题
			　　　const filterVal = ['name','brand','form','unit','count','price'];
			　　　// 上面的index、phone_Num、school_Name是tableData里对象的属性
			　　　const list = exportItems;  //把data里的tableData存到list
			　　　const data = this.formatJson(filterVal, list);
				 const fileName = '商品导出';
			　　　export_json_to_excel(tHeader, data, fileName);
			　})
			},
			formatJson(filterVal, jsonData) {
		     return jsonData.map(v => filterVal.map(j => v[j]))
		   	},
		   	//付款方式转换
			formatPayway: function (row, column) {
				return this.getStrByPayway(row.payway);
			},
			//格式化付款方式
			getStrByPayway(payway){
				let paywayStr = '';
				if(payway == 1){
					paywayStr="支付宝";
				}else if (payway == 2){
					paywayStr="微信";
				}else if (payway == 3){
					paywayStr="现金";
				}else if (payway == 4){
					paywayStr="记账";
				}else if (payway == 5){
					paywayStr="POS";
				}
				return paywayStr;
			},
			//获取销售公司列表
			getProviders() {
				let para = {
				};
				this.listLoading = true;
				getProviderList(para).then((res) => {
					this.listLoading = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.providers = res.data.data.list
	                }
				});
			},
			//获取需求公司列表
			getDemanders() {
				let para = {
                    role:2
				};
				this.listLoading = true;
				getDemanderList(para).then((res) => {
					this.listLoading = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.demanders = res.data.data.list
	                }
				});
			},
			//获取订单列表
			getOrders() {
				let start,end = '';
				if(this.filters.dates!='' && this.filters.dates!=undefined){
					start = util.formatDate.format(this.filters.dates[0],"yyyy-MM-dd 00:00:00");
					end = util.formatDate.format(this.filters.dates[1],"yyyy-MM-dd 23:59:59");
				}
				let para = {
					page:this.page,
                    size:this.pageSize,
                    cdSn:this.filters.cdSn,
                    providerId:this.filters.providerId,
                    demanderId:this.filters.demanderId,
                    payway:this.filters.payway,
                    remark:this.filters.remark,
                    startTime:start==undefined?'':start,
                    endTime:end==undefined?'':end,
				};
				this.listLoading = true;
				getOrderList(para).then((res) => {
					this.listLoading = false
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
	                	this.orders = res.data.data.list
	                    this.page = res.data.data.pageNum == 0 ? res.data.data.pageNum +1 : res.data.data.pageNum
	                    this.total = res.data.data.total
	                }
				});
			},
			
			//显示修改订单商品界面
			handleEditOrderGoods: function (){
				this.orderGoodsVisible = false;
				this.editOrderGoodsVisible = true;
				this.orderGoods = this.sels;
				//计算修改前金额和数量
				this.beforeEditCount = this.countGoodsCount(this.sels);
				this.beforeEditSum = this.countGoodsSum(this.sels);

			},
			//修改订单商品提交
			editOrderGoodsSubmit: function () {
				//计算修改后金额和数量
				this.afterEditSum = this.countGoodsSum(this.orderGoods);
				this.afterEditCount = this.countGoodsCount(this.orderGoods);
				//订单id
				this.editOrderGoodsForm.id = this.sendForm.id;
				//修改后总金额
				this.editOrderGoodsForm.sum = util.formatNumber(this.sendForm.sum + (this.afterEditSum - this.beforeEditSum));
				//修改后商品数量
				this.editOrderGoodsForm.count = this.sendForm.count + (this.afterEditCount - this.beforeEditCount);
				
				this.editOrderGoodsForm.goodsList = this.orderGoods;
				this.$confirm('确认提交吗？', '提示', {}).then(() => {
					this.editOrderGoodsLoading = true;
					this.editOrderGoodsVisible = false;
					editOrderDetail(this.editOrderGoodsForm).then((res) => {
						this.editOrderGoodsLoading = false;
						let msg = res.data.message;
	                	let code = res.data.code;
						if (code !== 200) {
		                  this.$message({
		                    message: msg,
		                    type: 'error'
		                  });
		                } else {
							this.$message({
								message: '提交成功',
								type: 'success'
							});
							this.getOrders();
						}
					});
				});
			},
			//删除订单商品
			handleDelOrderGoods: function () {
				if(this.sels.length==this.orderGoods.length){
					this.$message({
						message: '不能全部删除',
						type: 'error'
					});
					return;
				}
				//订单id
				this.delOrderGoodsForm.id = this.sendForm.id;
				//订单数量
				this.delOrderGoodsForm.count = this.sendForm.count - this.countGoodsCount(this.sels);
				//修改后总金额
				this.delOrderGoodsForm.sum = util.formatNumber(this.sendForm.sum - this.countGoodsSum(this.sels));

				this.delOrderGoodsForm.goodsList = this.sels;
				this.$confirm('确认删除吗？', '提示', {}).then(() => {
					this.editLoading = true;
					this.orderGoodsVisible = false;
					delOrderDetail(this.delOrderGoodsForm).then((res) => {
						this.editLoading = false;
						this.delOrderGoodsVisible = false;
						let msg = res.data.message;
	                	let code = res.data.code;
						if (code !== 200) {
		                  this.$message({
		                    message: msg,
		                    type: 'error'
		                  });
		                } else {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getOrders();
						}
					});
				});
			},
			
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
			},
			//编辑
			editSubmit: function () {
				this.editLoading = true;
				let para = { 
					id: this.editForm.id, 
					providerId: this.editForm.providerId,
					demanderId: this.editForm.demanderId,
					payway: this.editForm.payway
				};
				editOrder(para).then((res) => {
					this.editLoading = false;
					this.editFormVisible = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.$message({
							message: '提交成功',
							type: 'success'
						});
						this.getOrders();
						this.$refs['editForm'].resetFields();
					}
				});
			},
			//根据订单号获取商品列表
			getGoodsByOrderId(orderId) {
				let para = { 
					id: orderId 
				};
				this.orderGoodsLoading = true;
				getOrderDetail(para).then((res) => {
					this.orderGoodsLoading = false;
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						this.orderGoods = res.data.data
					}
				});
			},
			//查看送货单
			handleView: function(index, row){
				this.getGoodsByOrderId(row.id)
				this.orderGoodsVisible = true
				this.sendForm = Object.assign({}, row);
			},
			//冲红
			handleCopy: function (index, row) {
				//物料信息
				let that = this;
            	let addForm = {};
            	addForm.goodsList = [];
            	addForm.count = -row.count;
				addForm.sum = -row.sum;
            	addForm.providerId = row.providerId;
				addForm.demanderId = row.demanderId;
				let para = { 
					id: row.id 
				};
				getOrderDetail(para).then((res) => {
					let msg = res.data.message;
                	let code = res.data.code;
					if (code !== 200) {
	                  that.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
	                	res.data.data.forEach(good => {
							good.count = -good.count;
							addForm.goodsList.push(good);
						})
					}
				});

				setTimeout(function(){ 
	        		const {href} = that.$router.resolve({name: '销货单开具', query: {relatedResponse: JSON.stringify(addForm)}});
					window.open(href, '_blank');
				},1000+addForm.goodsList.length*100);
				// this.orderGoodsVisible = true
				// this.sendForm = Object.assign({}, row);

	   //      	addForm.sum = util.formatNumber(addForm.sum);
				// addForm.cdSn = row.poOrderCode;
				// addForm.providerId = 8;
				// addForm.demanderId = res.data.data.demanderId;
				// addForm.areaId = res.data.data.areaId;
				// addForm.typeId = res.data.data.typeId;
				// addForm.purchaserId = res.data.data.purchaserId;
				// addForm.remark = record.prOrderPurchaseDetailVO.prOrderReceiptDetailVO.receiptName + record.prOrderPurchaseDetailVO.prOrderReceiptDetailVO.receiptPhone + " " + record.prOrderPurchaseDetailVO.prOrderReceiptDetailVO.receiptAddress;
				
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					let para = { id: row.id, status: 0 };
					delOrder(para).then((res) => {
						this.listLoading = false;
						let msg = res.data.message;
	                	let code = res.data.code;
						if (code !== 200) {
		                  this.$message({
		                    message: msg,
		                    type: 'error'
		                  });
		                } else {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							this.getOrders();
						}
					});
				}).catch(() => {
				});
			},
			//显示需求公司新增界面
			handleDemanderAdd: function () {
				this.addDemanderFormVisible = true;
				this.addDemanderForm = {
					role: 2,
					name: '',
					contacter: '',
					phone: ''
				};
			},
			//新增
			addDemanderSubmit: function () {
				this.$refs.addDemanderForm.validate((valid) => {
					if (valid) {
						this.addDemanderLoading = true;
						let para = Object.assign({}, this.addDemanderForm);
						addDemander(para).then((res) => {
							this.addDemanderLoading = false;
							this.addDemanderFormVisible = false;
							let msg = res.data.message;
		                	let code = res.data.code;
							if (code !== 200) {
			                  this.$message({
			                    message: msg,
			                    type: 'error'
			                  });
			                } else {
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								this.$refs['addDemanderForm'].resetFields();
								this.getDemanders();
							}
						});
					}
				});
			},

			//计算商品数量
			countGoodsCount(goods){
				let count = 0;
				goods.forEach(item => {
					count += item.count*1
				})
				return util.formatNumber(count);
			},
			//计算商品金额
			countGoodsSum(goods){
				let sum = 0;
				goods.forEach(item => {
					sum += item.count*item.price
				})
				return util.formatNumber(sum);
			},
			
		    //初始化送货单
		    initPrintData:function(){
		    	this.pages = Math.ceil(this.sels.length / this.printSize);
		    	//规定纸张大小
				// LODOP.SET_PRINT_PAGESIZE(1,"24.1cm","9.3cm","CreateCustomPage");
				LODOP.SET_PRINT_PAGESIZE(1,"24.1cm","13.95cm","CreateCustomPage");
				
				for(let currentPage=0; currentPage<this.pages; currentPage++){
					this.drawSendOrder(currentPage);
				}
		    },
		    //送货单分页
		    drawSendOrder:function(page){
		    	LODOP.NewPage();
	    		this.loadPrintTemplate1(page);
		    },
		    //送货单模版
		    loadPrintTemplate:function(page){
		    	//抬头
		    	LODOP.ADD_PRINT_TEXT(35,132,506,25,this.sendForm.provider);
		    	LODOP.SET_PRINT_STYLEA(0,"FontSize",18);
		    	LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
		    	LODOP.SET_PRINT_STYLEA(0,"Bold",1);
		    	LODOP.ADD_PRINT_TEXT(35,630,100,25,"第"+(page+1)+"/"+this.pages+"页");
		    	LODOP.SET_PRINT_STYLEA(0,"FontSize",9);
		    	LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
		    	
		    	LODOP.ADD_PRINT_TEXT(74,52,51,20,"客户：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
		    	LODOP.ADD_PRINT_TEXT(74,89,403,20,this.sendForm.demander);
		    	LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
		    	LODOP.ADD_PRINT_TEXT(94,52,51,20,"摘要：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(74,545,80,20,"单据编号：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(74,606,144,19,this.sendForm.cdSn);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(94,545,80,20,"开单日期：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				// LODOP.ADD_PRINT_TEXT(94,606,144,19,util.formatDate.format(new Date(),'yyyy年MM月dd日'));
				LODOP.ADD_PRINT_TEXT(94,606,144,19,this.sendForm.createTime);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				//表头
				LODOP.ADD_PRINT_TEXT(118,57,50,20,"序号");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,588,80,20,"金额");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,452,66,20,"数量");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,408,44,20,"单位");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,107,118,20,"产品名称");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,226,182,20,"规格型号");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,518,70,20,"单价");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,668,80,20,"备注");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);

				//表头划线
				LODOP.ADD_PRINT_LINE(116,57,134,57,0,1);
				LODOP.ADD_PRINT_LINE(116,107,134,107,0,1);
				LODOP.ADD_PRINT_LINE(116,226,134,226,0,1);
				LODOP.ADD_PRINT_LINE(116,408,134,408,0,1);
				LODOP.ADD_PRINT_LINE(116,452,134,452,0,1);
				LODOP.ADD_PRINT_LINE(116,518,134,518,0,1);
				LODOP.ADD_PRINT_LINE(116,588,134,588,0,1);
				LODOP.ADD_PRINT_LINE(116,668,134,668,0,1);
				LODOP.ADD_PRINT_LINE(116,748,134,748,0,1);
				LODOP.ADD_PRINT_LINE(116,57,116,748,0,1);

				//--行内容
				let sum = 0;
				let restCount = this.sels.length - page*this.printSize;
				for (let j = page*this.printSize; j <  (restCount<this.printSize?this.sels.length:this.printSize*(page+1)); j++) {
					let i = j+1;
					let item = this.sels[j];
					//序号
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,57,50,20,i);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//名称
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,107,118,20,item.name);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//规格
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,226,182,20,item.form);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//单位
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,408,44,20,item.unit);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//数量
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,452,66,20,item.count);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//单价
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,518,70,20,util.formatNumber(item.price));
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//总金额
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,588,80,20,util.formatNumber(item.count*item.price));
					LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					sum += (item.count*item.price);
				}
				sum = util.formatNumber(sum);

				//表格画线
				for (let i = 1; i <= this.printSize; i++) {
					LODOP.ADD_PRINT_LINE(116+18*i,57,116+18*i,748,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,57,136+18*i,57,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,107,136+18*i,107,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,226,136+18*i,226,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,408,136+18*i,408,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,452,136+18*i,452,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,518,136+18*i,518,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,588,136+18*i,588,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,668,136+18*i,668,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,748,136+18*i,748,0,1);
				}
				//三横
				LODOP.ADD_PRINT_LINE(134+18*this.printSize,57,134+18*this.printSize,748,0,1);
				LODOP.ADD_PRINT_LINE(134+18*(this.printSize+1),57,134+18*(this.printSize+1),748,0,1);
				LODOP.ADD_PRINT_LINE(134+18*(this.printSize+2),57,134+18*(this.printSize+2),748,0,1);
				//三竖
				LODOP.ADD_PRINT_LINE(134+18*this.printSize,57,134+18*(this.printSize+2),57,0,1);
				LODOP.ADD_PRINT_LINE(134+18*this.printSize,518,134+18*(this.printSize+2),518,0,1);
				LODOP.ADD_PRINT_LINE(134+18*this.printSize,748,134+18*(this.printSize+2),748,0,1);
				
				//表尾
				LODOP.ADD_PRINT_TEXT(246,550,85,20,"本页小计：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(246,612,138,20,sum);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(264,550,85,20,"总计小写：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(264,612,138,20,this.selSum);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(264,120,85,20,"总计大写：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Bold",1);
				LODOP.ADD_PRINT_TEXT(264,186,213,20,util.DX(this.selSum));
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.SET_PRINT_STYLEA(0,"Bold",1);

				LODOP.ADD_PRINT_TEXT(282,60,80,20,"门店地址：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(282,120,250,20,this.sendForm.providerAddress);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(282,370,70,20,"负责人：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(282,420,70,20,this.sendForm.providerManager);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(282,490,60,20,"电话：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(282,530,100,20,this.sendForm.providerPhone);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(282,630,70,20,"制单人：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				LODOP.ADD_PRINT_TEXT(282,680,70,20,this.sendForm.providerManager);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);

		    },
		    //送货单模版
		    loadPrintTemplate1:function(page){
		    	//抬头
		    	LODOP.ADD_PRINT_TEXT(35,132,506,25,this.sendForm.provider);
		    	LODOP.SET_PRINT_STYLEA(0,"FontSize",18);
		    	LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
		    	LODOP.SET_PRINT_STYLEA(0,"Bold",1);
		    	LODOP.ADD_PRINT_TEXT(35,630,100,25,"第"+(page+1)+"/"+this.pages+"页");
		    	LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
		    	LODOP.SET_PRINT_STYLEA(0,"Alignment",3);
		    	
		    	let fontSize = 11;
		    	LODOP.ADD_PRINT_TEXT(74,52,55,20,"客户：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
		    	LODOP.ADD_PRINT_TEXT(74,95,403,20,this.sendForm.demander);
		    	LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
		    	LODOP.ADD_PRINT_TEXT(94,52,55,20,"摘要：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(74,545,90,20,"单据编号：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(74,620,144,19,this.sendForm.cdSn);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(94,545,80,20,"开单日期：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",10);
				// LODOP.ADD_PRINT_TEXT(94,606,144,19,util.formatDate.format(new Date(),'yyyy年MM月dd日'));
				LODOP.ADD_PRINT_TEXT(94,606,144,19,this.sendForm.createTime);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				//表头
				LODOP.ADD_PRINT_TEXT(118,57,50,20,"序号");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,588,80,20,"金额");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,452,66,20,"数量");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,408,44,20,"单位");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,107,118,20,"产品名称");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,226,182,20,"规格型号");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,518,70,20,"单价");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
				LODOP.ADD_PRINT_TEXT(118,668,80,20,"备注");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.SET_PRINT_STYLEA(0,"Alignment",2);

				//表头划线
				LODOP.ADD_PRINT_LINE(116,57,134,57,0,1);
				LODOP.ADD_PRINT_LINE(116,107,134,107,0,1);
				LODOP.ADD_PRINT_LINE(116,226,134,226,0,1);
				LODOP.ADD_PRINT_LINE(116,408,134,408,0,1);
				LODOP.ADD_PRINT_LINE(116,452,134,452,0,1);
				LODOP.ADD_PRINT_LINE(116,518,134,518,0,1);
				LODOP.ADD_PRINT_LINE(116,588,134,588,0,1);
				LODOP.ADD_PRINT_LINE(116,668,134,668,0,1);
				LODOP.ADD_PRINT_LINE(116,748,134,748,0,1);
				LODOP.ADD_PRINT_LINE(116,57,116,748,0,1);

				//--行内容
				let sum = 0;
				let restCount = this.sels.length - page*this.printSize;
				//当前页数据大小
				let currentPageSize = (restCount>this.printSize?this.printSize:restCount);

				for (let j = page*this.printSize; j <  (restCount<this.printSize?this.sels.length:this.printSize*(page+1)); j++) {
					let i = j+1;
					let item = this.sels[j];
					//序号
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,57,50,20,i);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//名称
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,107,118,20,item.name);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//规格
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,226,182,20,item.form);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//单位
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,408,44,20,item.unit);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//数量
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,452,66,20,item.count);
					LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//单价
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,518,70,20,util.formatNumber(item.price));
					LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					//总金额
					LODOP.ADD_PRINT_TEXT(118+18*i-216*page,588,80,20,util.formatNumber(item.count*item.price));
					LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
					LODOP.SET_PRINT_STYLEA(0,"Alignment",2);
					sum += (item.count*item.price);
				}
				sum = util.formatNumber(sum);

				//表格画线
				for (let i = 1; i <= currentPageSize; i++) {
					LODOP.ADD_PRINT_LINE(116+18*i,57,116+18*i,748,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,57,134+18*i,57,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,107,134+18*i,107,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,226,134+18*i,226,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,408,134+18*i,408,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,452,134+18*i,452,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,518,134+18*i,518,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,588,134+18*i,588,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,668,134+18*i,668,0,1);
					LODOP.ADD_PRINT_LINE(116+18*i,748,134+18*i,748,0,1);
				}
				//三横
				LODOP.ADD_PRINT_LINE(134+18*currentPageSize,57,134+18*currentPageSize,748,0,1);
				LODOP.ADD_PRINT_LINE(134+18*(currentPageSize+1),57,134+18*(currentPageSize+1),748,0,1);
				LODOP.ADD_PRINT_LINE(134+18*(currentPageSize+2),57,134+18*(currentPageSize+2),748,0,1);
				//三竖
				LODOP.ADD_PRINT_LINE(134+18*currentPageSize,57,134+18*(currentPageSize+2),57,0,1);
				LODOP.ADD_PRINT_LINE(134+18*currentPageSize,518,134+18*(currentPageSize+2),518,0,1);
				LODOP.ADD_PRINT_LINE(134+18*currentPageSize,748,134+18*(currentPageSize+2),748,0,1);
				
				//表尾
				LODOP.ADD_PRINT_TEXT(246-108+18*currentPageSize,550,85,20,"本页小计：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(246-108+18*currentPageSize,618,138,20,sum);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(264-108+18*currentPageSize,550,85,20,"总计小写：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(264-108+18*currentPageSize,618,138,20,this.selSum);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(264-108+18*currentPageSize,120,95,20,"总计大写：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.SET_PRINT_STYLEA(0,"Bold",1);
				LODOP.ADD_PRINT_TEXT(264-108+18*currentPageSize,190,213,20,util.DX(this.selSum));
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.SET_PRINT_STYLEA(0,"Bold",1);

				LODOP.ADD_PRINT_TEXT(282-108+18*currentPageSize,60,90,20,"门店地址：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(282-108+18*currentPageSize,125,250,20,this.sendForm.providerAddress);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(282-108+18*currentPageSize,370,70,20,"负责人：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(282-108+18*currentPageSize,422,70,20,this.sendForm.providerManager);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(282-108+18*currentPageSize,490,60,20,"电话：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(282-108+18*currentPageSize,530,100,20,this.sendForm.providerPhone);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(282-108+18*currentPageSize,630,70,20,"制单人：");
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);
				LODOP.ADD_PRINT_TEXT(282-108+18*currentPageSize,682,70,20,this.sendForm.providerManager);
				LODOP.SET_PRINT_STYLEA(0,"FontSize",fontSize);

		    },
		    handlePrint: function(){
		    	LODOP=getLodop();  
				this.initPrintData();
				LODOP.PREVIEW();//打印预览
				// LODOP.PRINT();//打印
		    },
		    handleDesign: function(){
		    	LODOP=getLodop();  
				this.initPrintData();
				LODOP.PRINT_DESIGN();//打印设计	
		    },

		    //跳转新增页面
			goAddView: function () {
				this.$router.push({path: '/order/add'});
			},
			//获取首字母
			getFirstLetter:function(){
				this.addGoodsForm.firstLetter = pinyinUtil.getFirstLetter(this.addGoodsForm.name);
			},

			//导出全部物料
			exportAll() {
				let exportItems=[];
				let start,end = '';
				if(this.filters.dates!='' && this.filters.dates!=undefined){
					start = util.formatDate.format(this.filters.dates[0],"yyyy-MM-dd 00:00:00");
					end = util.formatDate.format(this.filters.dates[1],"yyyy-MM-dd 23:59:59");
				}
				let para = {
                    cdSn:this.filters.cdSn,
                    demanderId:this.filters.demanderId,
                    payway:this.filters.payway,
                    remark:this.filters.remark,
                    startTime:start==undefined?'':start,
                    endTime:end==undefined?'':end,
				};
				getOrderListExport(para).then((res) => {
					let msg = res.data.message;
	            	let code = res.data.code;
					if (code !== 200) {
	                  this.$message({
	                    message: msg,
	                    type: 'error'
	                  });
	                } else {
						exportItems = res.data.data.list
						require.ensure([], () => {
					　　　const { export_json_to_excel } = require('../../excel/Export2Excel');
					　　　const tHeader = ['订单号','日期','名称','品牌','规格','单位','数量','价格','总计'];
					　　　// 上面设置Excel的表格第一行的标题
					　　　const filterVal = ['barCode','stockTime','name','brand','form','unit','count','price','bidPrice'];
					　　　// 上面的index、phone_Num、school_Name是tableData里对象的属性
					　　　const list = exportItems;  //把data里的tableData存到list
					　　　const data = this.formatJson(filterVal, list);
						 const demander = (para.demanderId==''?'':this.orders[0].demander+' ');
						 const date = (start==undefined?'':util.formatDate.format(this.filters.dates[0],"yyyy.MM.dd")+'-'+ util.formatDate.format(this.filters.dates[1],"yyyy.MM.dd"));
						 const fileName = demander.trim() + date + '对账单';
					　　　export_json_to_excel(tHeader, data, fileName);
					　})
	                }
				});
			},
    		
		},
		mounted() {
			this.getProviders();
			this.getDemanders();
			let res = this.$route.params.relatedResponse || this.$route.query.relatedResponse;
			if(res == undefined){
				this.getOrders();
			}else{
				if(res.data.data.name){
					this.canHistory=true
				}
				this.orders = res.data.data.list
                this.page = res.data.data.pageNum == 0 ? res.data.data.pageNum +1 : res.data.data.pageNum
            	this.total = res.data.data.total
            	this.pageSize = res.data.data.pageSize
			}
		}
	}

</script>

<style scoped>
	i:hover{ 
		color:#999;
		cursor: pointer;
	}
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

</style>